import * as React from "react"
import "../styles/layout.scss"
import "../styles/global.scss"
import {ParallaxProvider} from 'react-scroll-parallax';


import Header from "../pages/accueil/header"
import Footer from "../pages/accueil/footer";

export default function Layout({children}) {
    return (
        <div className='layout'>
            <Header/>
            <div>
                <ParallaxProvider>
                    <main>{children}</main>
                </ParallaxProvider>
            </div>
            <Footer/>
        </div>
    )
}
